<template>
  <div>
    <v-layout wrap>
      <v-flex xs6>
        {{ $t('Set time') }}
        <div class="d-flex" v-if="!isEdit">
          <template v-for="(item, index) in timeSetting">
            <v-tooltip :key="`item-time-${index}`" top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  small
                  :color="
                    item.isToday && item.isActive
                      ? '#a0e83d'
                      : item.isToday && !item.isActive
                      ? 'red'
                      : ''
                  "
                  text-color="white"
                  :disabled="!item.isToday"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.day }}
                </v-chip>
              </template>
              <span>{{ item.status ? item.timeLength : $t('Not activated') }}</span>
            </v-tooltip>
          </template>
        </div>
      </v-flex>
      <v-flex xs6 class="text-xs-right">
        <template v-if="isEdit"></template>
        <template v-else>
          <v-btn fab small outline color="primary" @click="isEdit = true">
            <i class="fas fa-pencil-alt"></i>
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
    <v-card class="mt-2 pa-3">
      <div class="pa-2 hidden-xs-only">
        <v-layout wrap>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Date_1') }}</v-flex>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Open at') }}</v-flex>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Close at') }}</v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
      <template v-for="(time, key) in timetable">
        <open-time-bot-item :key="key" v-model="timetable[key]" :name="key" :isEdit="isEdit">
        </open-time-bot-item>
      </template>
    </v-card>
    <div class="text-xs-center mt-4" v-if="isEdit">
      <v-btn color="grey" outline @click="onCancelTimeTable">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="onSaveTimeTable">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import OpenTimeBotItem from './OpenTimeBotItem'

const dayItems = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
const dayAbb = {
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
  Sunday: 'Sun'
}
const day = dayjs().day()
const dayMatch = dayItems[day === 0 ? dayItems.length : day - 1]
const today = dayjs().format('YYYY-MM-DD')

export default {
  data() {
    return {
      isEdit: false,
      timetable: {
        Monday: { status: true, openat: null, closeat: null },
        Tuesday: { status: true, openat: null, closeat: null },
        Wednesday: { status: true, openat: null, closeat: null },
        Thursday: { status: true, openat: null, closeat: null },
        Friday: { status: true, openat: null, closeat: null },
        Saturday: { status: true, openat: null, closeat: null },
        Sunday: { status: true, openat: null, closeat: null }
      }
    }
  },
  components: {
    OpenTimeBotItem
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    timeSetting() {
      if (this.timetable) {
        let days = []
        for (const key of Object.keys(this.timetable)) {
          const timeSettingInfo = this.timetable[key]

          const open = !timeSettingInfo.openat
            ? '00:00'
            : dayjs(`${today}T${timeSettingInfo.openat.slice(0, 5)}:00`).format('HH:mm')
          const close = timeSettingInfo.closeat && timeSettingInfo.closeat.slice(0, 5) !== '24:00'
            ?  dayjs(`${today}T${timeSettingInfo.closeat.slice(0, 5)}:00`).format('HH:mm')
            : '24:00'

          let start = null
          let end = null

          start = timeSettingInfo.openat
            ? today +
              ' ' +
              dayjs(`${today}T${timeSettingInfo.openat.slice(0, 5)}:00`).format('HH:mm')
            : today + ' ' + dayjs(`${today}T00:00:00`).format('HH:mm')

          end =
            timeSettingInfo.closeat && timeSettingInfo.closeat.slice(0, 5) !== '24:00'
              ? today +
                ' ' +
                dayjs(`${today}T${timeSettingInfo.closeat.slice(0, 5)}:00`).format('HH:mm')
              : today + ' ' + dayjs(`${today}T23:59:59`).format('HH:mm')

          const inTime =
            (!timeSettingInfo.closeat && !timeSettingInfo.openat) ||
            (start && end && dayjs().isBetween(dayjs(start), dayjs(end)))

          days.push({
            ...timeSettingInfo,
            isToday: dayMatch === key,
            isActive: dayMatch === key && timeSettingInfo.status && inTime,
            day: this.$t(dayAbb[key]),
            timeLength: `${open} - ${close}`
          })
        }
        return days
      } else {
        return []
      }
    }
  },
  mounted() {
    this.getTimeToUseBot()
  },
  methods: {
    getTimeToUseBot: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getTimeToUseBot({ pageid: this.selectedBot.pageid }, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            if (response.data.timetousebot) {
              if (response.data.timetousebot) {
                vm.timetable = JSON.parse(response.data.timetousebot)
              } else {
                vm.timetable = {
                  Monday: { status: true, openat: null, closeat: null },
                  Tuesday: { status: true, openat: null, closeat: null },
                  Wednesday: { status: true, openat: null, closeat: null },
                  Thursday: { status: true, openat: null, closeat: null },
                  Friday: { status: true, openat: null, closeat: null },
                  Saturday: { status: true, openat: null, closeat: null },
                  Sunday: { status: true, openat: null, closeat: null }
                }
              }

              vm.cached_timetable = JSON.stringify(vm.timetable)
            }
            vm.cached_timetable = JSON.stringify(vm.timetable)
          }
          resolve()
        })
      })
    },
    onCancelTimeTable: function() {
      var vm = this
      vm.timetable = JSON.parse(vm.cached_timetable)
      vm.isEdit = false
    },
    onSaveTimeTable: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$validator.validateAll().then(result => {
          if (!result) {
            // do stuff if not valid.
            vm.goToErrorInput()
            reject()
            return false
          }
          var data = {
            timetousebot: JSON.stringify(vm.timetable),
            pageid: this.selectedBot.pageid
          }
          api.saveTimeToUseBot(data, function(error, response) {
            if (error) {
              reject(error)
            }
            vm.cached_timetable = JSON.stringify(vm.timetable)
            vm.isEdit = false
            resolve()
          })
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-chip {
  display: flex !important;
  justify-content: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/billing/ManageOpenTimeBot.vue